export const renderFormattedText = (text) => {
  if (!text) return null;

  let parts = [text];

  if (text.includes('\n')) {
    parts = text.split('\n');
  }

  return parts.map((part, lineIndex) => {
    if (typeof part === "string" && part.includes("**")) {
      const boldParts = part.split(/(\*\*.*?\*\*)/g);
      const renderedPart = boldParts.map((segment, i) => {
        if (segment.startsWith("**") && segment.endsWith("**")) {
          return <strong key={`${lineIndex}-${i}`}>{segment.slice(2, -2)}</strong>;
        }
        return <span key={`${lineIndex}-${i}`}>{segment}</span>;
      });

      return (
        <span key={lineIndex}>
          {renderedPart}
          {lineIndex < parts.length - 1 && <br />}
        </span>
      );
    }

    return (
      <span key={lineIndex}>
        {part}
        {lineIndex < parts.length - 1 && <br />}
      </span>
    );
  });
};
